var Constants = /** @class */ (function () {
    function Constants() {
    }
    Constants.DEFAULT_HELP_LINK = "";
    return Constants;
}());
export { Constants };
